import { atom } from 'jotai';

export interface IFilePreviewState {
  url: string;
  mimeType: string;
  fileId?: string | number;
}

const initialFilePreview: IFilePreviewState | null = null;

export const filePreviewAtom = atom(initialFilePreview);
